import * as React from 'react';
var TriggerContext = /*#__PURE__*/React.createContext(null);
export default TriggerContext;


//////////////////
// WEBPACK FOOTER
// ./~/rc-trigger/es/context.js
// module id = 2210
// module chunks = 0